<template>
	<v-card class="mt-4">
		<contest-documents-list
			:contest-id="contestData.id"
			:documents="contestDocuments"
			color="blue"
			document-type="CONTEST_DOCUMENT"
			header="Dokumenty Konkursowe"
			:read-only="true"
		/>
		<contest-documents-list
			class="mt-4"
			:contest-id="contestData.id"
			:documents="infoDocuments"
			color="blue"
			document-type="INFO_DOCUMENT"
			header="Dokumenty Informacyjne"
			:read-only="true"
		/>
	</v-card>
</template>

<script>
	import ContestDocumentsList from "./components/ContestDocumentsList";
	import {PublicContestDocument} from "@/api/generated/PublicContestDocument";

	export default {
		name: "ContestReadOnlyDocumentsView",

		components: {ContestDocumentsList},

		data() {
			return {
				contestData: {
					id: this.$route.params.id,
				},
				contestDocuments: [],
				infoDocuments: [],
			};
		},

		created() {
			loadDocuments(this);
		},
	};

	function loadDocuments(ctx) {
		PublicContestDocument.getReadOnly(ctx, ctx.contestData.id,
			successResponse => {
				successResponse.forEach(function (document) {
					addDocumentToView(ctx, document);
				});
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować dokumentów", errorResponse);
			});
	}

	function addDocumentToView(ctx, document) {
		if (document.publicContestDocumentType === "CONTEST_DOCUMENT") {
			ctx.contestDocuments.push(document);
		} else {
			ctx.infoDocuments.push(document);
		}
	}
</script>

<style scoped>

</style>
